export const COMMON_WORDS = new Set([
  "the", "and", "a", "an", "in", "on", "at", "to", "for", "of", "with", "by",
  "from", "up", "about", "into", "over", "after", "it", "is", "are", "was",
  "were", "be", "been", "being", "have", "has", "had", "do", "does", "did",
  "but", "that", "which", "who", "whom", "whose", "what", "where", "when",
  "why", "how", "all", "any", "both", "each", "few", "more", "most", "other",
  "some", "such", "no", "nor", "not", "only", "own", "same", "so", "than",
  "too", "very", "can", "will", "just", "should", "now"
]);